import React from 'react';
import {withRouter} from 'react-router-dom';
import cn from 'classnames';

import style from 'components/common/Form/Button/Button.module.scss';

export const ButtonStyles = {
    default: style.default,

    primary: style.primaryBtn,
    secondary: style.secondaryBtn,
    danger: style.danger,

    red: style.red,
    primaryLight: style.primaryLight,
    error: style.error,
    userMenu: style.userMenu,
    adminNew: style.adminNewBtn,
    adminOrders: style.adminOrders,
    optionNew: style.optionNewBtn,
    dimmed: style.dimmed,
    dimmedThin: style.dimmedThin,
    small: style.small,
    dark: style.dark,
    newLight: style.newLight,
    newCancel: style.newCancel,
    white: style.white,
    dangerLight: style.dangerLight,
    lightGreenColored: style.lightGreenColored,
    blue: style.blue,
    whiteShadow: style.whiteShadow,
    green: style.green,
};

const Button = ({
    leftIcon,
    rightIcon,
    btnStyle,
    onClick,
    text,
    className,
    disabled,
    href,
    history,
    id,
    staticContext,
    ...rest
}) => {
    const btnClass = cn(style.button, btnStyle, {
        [style.disabled]: disabled,
        [className]: className,
    });

    const handleClick = ev => {
        if (href) {
            history.push(href);
        }

        if (onClick) {
            onClick(ev);
        }
    };

    return (
        <button className={btnClass} onClick={handleClick} id={id} {...rest}>
            {leftIcon}
            {text && <span className={style.text}>{text}</span>}
            {rightIcon}
        </button>
    );
};

Button.defaultProps = {
    btnStyle: ButtonStyles.secondary,
};

export default withRouter(Button);
